import { FormField, FormRenderTypes } from "../Shared/Components/FormRenderer";
import { FormRenderGroupTypes } from "../Shared/Components/FormRenderer/FormRenderGroup.types";
import { InvoiceSchemeOptions } from '../Invoices/Types/invoicesLabels';
import { Offer } from './Types/offerTypes';

export const offerFields: FormField<Offer>[] = [
  {
    name: 'name',
    label: 'Nazwa oferty',
    type: FormRenderTypes.input,
    value: '',
    placeholder: 'Wprowadź nazwę oferty',
    group: FormRenderGroupTypes.basic,
  },

  {
    name: 'shortDescription',
    label: 'Krótki opis',
    type: FormRenderTypes.input,
    value: '',
    placeholder: 'Wprowadź krótki opis oferty',
    group: FormRenderGroupTypes.basic,
  },
  {
    name: 'description',
    label: 'Opis',
    type: FormRenderTypes.wysiwyg,
    value: '',
    placeholder: 'Opis oferty',
    group: FormRenderGroupTypes.basic,
  },
  {
    name: 'priceIncludes',
    label: 'Cena zawiera',
    type: FormRenderTypes.wysiwyg,
    value: '',
    placeholder: 'Wprowadź informacje, co zawiera cena',
    group: FormRenderGroupTypes.additionalInformation,
  },
  {
    name: 'additionalPaid',
    label: 'Dodatkowo płatne',
    type: FormRenderTypes.wysiwyg,
    value: '',
    placeholder: 'Wprowadź informacje, co jest dodatkowo płatne',
    group: FormRenderGroupTypes.additionalInformation,
  },
  {
    name: 'importantInformation',
    label: 'Ważne informacje',
    type: FormRenderTypes.wysiwyg,
    value: '',
    placeholder: 'Wprowadź ważne informacje',
    group: FormRenderGroupTypes.additionalInformation,
  },
  {
    name: 'metaTitle',
    label: 'Tytuł meta',
    type: FormRenderTypes.input,
    value: '',
    placeholder: 'Wprowadź tytuł meta',
    group: FormRenderGroupTypes.seo,
  },
  {
    name: 'metaDescription',
    label: 'Opis meta',
    type: FormRenderTypes.textarea,
    value: '',
    placeholder: 'Wprowadź opis meta',
    group: FormRenderGroupTypes.seo,
  },
  {
    name: 'metaKeywords',
    label: 'Słowa kluczowe meta',
    type: FormRenderTypes.input,
    value: '',
    placeholder: 'Wprowadź słowa kluczowe meta',
    group: FormRenderGroupTypes.seo,
  },
  {
    name: 'hotelId',
    label: 'Wybierz hotel',
    type: FormRenderTypes.autocomplete,
    value: '',
    placeholder: 'Wybierz hotel',
    group: FormRenderGroupTypes.basic,
  },
  {
    name: 'regionId',
    label: 'Wybierz region',
    type: FormRenderTypes.autocomplete,
    value: '',
    placeholder: 'Wybierz region',
    group: FormRenderGroupTypes.basic,
  },

  {
    name: 'countryId',
    label: 'Wybierz kraj',
    type: FormRenderTypes.autocomplete,
    value: '',
    placeholder: 'Wybierz kraj',
    group: FormRenderGroupTypes.basic,
  },
  {
    name: 'offerCategoryIds',
    label: 'Wybierz kategorię',
    type: FormRenderTypes.autocomplete,
    multiple: true,
    value: [],
    placeholder: 'Wybierz kategorię',
    group: FormRenderGroupTypes.basic,
  },
  {
    name: 'offerTagIds',
    label: 'Wybierz tag',
    type: FormRenderTypes.autocomplete,
    multiple: true,
    value: [],
    placeholder: 'Wybierz tag',
    group: FormRenderGroupTypes.basic,
  },
  {
    name: 'companyId',
    label: 'Wybierz firmę',
    type: FormRenderTypes.autocomplete,
    value: '',
    placeholder: 'Wybierz firmę',
    group: FormRenderGroupTypes.basic,
  },
  {
    name: 'published',
    label: 'Opublikowana',
    type: FormRenderTypes.switch,
    value: '',
    placeholder: 'Opublikowana',
    group: FormRenderGroupTypes.configuration,
  },
  {
    name: 'defaultInvoiceScheme',
    label: 'Domyślny schemat faktury',
    type: FormRenderTypes.autocomplete,
    value: null,
    placeholder: 'Wybierz domyślny schemat faktury',
    options: InvoiceSchemeOptions,
    group: FormRenderGroupTypes.configuration,
  },
];
